/* ==========================================================================
   Impact figures — count up when they scroll into view.

   Deliberate behaviour around unconfirmed data:
   the element's final text is always rendered server-side. This script only
   animates from a lower number up to that text. If the value is not numeric
   (for example "TBC" or "Thousands"), nothing animates and the text is left
   exactly as written. So a placeholder can never be mistaken for a counted
   figure, and with JavaScript off every figure still reads correctly.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function parseNumeric(text) {
    // Accepts 3500, 3,500, 3500+, 3,500+ — and nothing else.
    var match = String(text).trim().match(/^([\d,]+)(\D*)$/);
    if (!match) return null;
    var digits = match[1].replace(/,/g, '');
    if (!digits.length) return null;
    return { value: parseInt(digits, 10), suffix: match[2] || '', grouped: match[1].indexOf(',') !== -1 };
  }

  function format(value, grouped) {
    return grouped ? value.toLocaleString() : String(value);
  }

  function countUp(el) {
    var parsed = parseNumeric(el.textContent);
    if (!parsed || reduceMotion.matches) return; // leave the text untouched

    var target = parsed.value;
    var duration = 1100;
    var started = null;

    function frame(now) {
      if (started === null) started = now;
      var progress = Math.min((now - started) / duration, 1);
      // easeOutCubic: quick, then settles
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = format(Math.round(target * eased), parsed.grouped) + parsed.suffix;
      if (progress < 1) window.requestAnimationFrame(frame);
    }

    window.requestAnimationFrame(frame);
  }

  function init(root) {
    var targets = (root || document).querySelectorAll('[data-lk-count-up]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) return; // text already correct

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countUp(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
